import { Draft } from 'immer';
import { Store, Common } from 'interfaces';
import updateError from './updateError';
import updateAvailability from './updateAvailability';
import resetAppState from './resetAppState';

const actions: (state: Draft<Store.State>) => Store.Actions = state => {
  return {
    reset() {
      return state;
    },

    updateError(error?: Common.Error) {
      updateError(state, error);
    },

    updateAvailability(availability: Common.Availability, startTime?: string) {
      updateAvailability(state, availability, startTime);
    },

    resetAppState() {
      resetAppState(state);
    },

    startTransaction() {
      state.transactionStartTs = +new Date();
    },

    setTransactionId(id: string) {
      state.transactionID = id;
    }
  };
};

export default actions;
